var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":"primary","outline":""},on:{"click":function($event){return _vm.$store.commit('stepper/previousStep')}}},'v-btn',_vm.$props,false),[_vm._v("\n    "+_vm._s(_vm.__('general.previous'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }